import React from "react";
import useScrollToTop from "./../../../hooks/useScollToTop";

import useProjetsAdmin from "./hooks/useProjetsAdmin";

import ProjetsHero from "./components/ProjetsHero";
import ProjetsStatsGrid from "./components/ProjetsStatsGrid";
import ProjetsFiltersPanel from "./components/ProjetsFiltersPanel";
import ProjetsList from "./components/ProjetsList";
import ProjetsFormDrawer from "./components/ProjetsFormDrawer";
import ProjetsPreviewDrawer from "./components/ProjetsPreviewDrawer";
import ProjetsDeleteDrawer from "./components/ProjetsDeleteDrawer";

import AdminMediaPickerDrawer from "../_shared/ui/AdminMediaPickerDrawer";
import { PROJETS_MEDIA_CATEGORY_DEFAULT } from "./data/projetsAdminData";

export default function ProjetsAdmin() {
  useScrollToTop();
  const projets = useProjetsAdmin();

  return (
    <div className="mx-auto w-full max-w-[1600px] px-1 pb-10 sm:px-2 lg:px-0">
      <ProjetsHero
        stats={projets.stats}
        loading={projets.loading}
        onCreate={projets.openCreate}
      />

      {projets.notice ? (
        <div className="mt-5 rounded-[1.5rem] border border-emerald-200 bg-emerald-50 px-5 py-4 text-sm font-bold text-emerald-800 shadow-sm dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300">
          {projets.notice}
        </div>
      ) : null}

      {projets.error ? (
        <div className="mt-5 rounded-[1.5rem] border border-rose-200 bg-rose-50 px-5 py-4 text-sm font-bold text-rose-800 shadow-sm dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300">
          {projets.error}
        </div>
      ) : null}

      <ProjetsStatsGrid stats={projets.stats} loading={projets.loading} />

      <ProjetsFiltersPanel
        q={projets.q}
        stateFilter={projets.stateFilter}
        limit={projets.limit}
        onChangeQ={projets.setQ}
        onChangeStateFilter={projets.changeStateFilter}
        onChangeLimit={projets.changeLimit}
        onSubmit={projets.onSubmitSearch}
        onReset={projets.resetFilters}
        onRefresh={projets.fetchData}
        loading={projets.loading}
      />

      <ProjetsList
        items={projets.items}
        loading={projets.loading}
        total={projets.total}
        page={projets.page}
        totalPages={projets.totalPages}
        actionId={projets.actionId}
        onPageChange={projets.setPage}
        onPreview={projets.openPreview}
        onEdit={projets.openEdit}
        onToggle={projets.onToggle}
        onAskDelete={projets.openDelete}
      />

      <ProjetsFormDrawer
        open={projets.formOpen}
        form={projets.form}
        fieldErrors={projets.fieldErrors}
        saving={projets.saving}
        isEdit={!!projets.currentId}
        onClose={projets.closeForm}
        onChange={projets.updateFormField}
        onSave={projets.onSave}
        onOpenMediaPicker={projets.openMediaPicker}
      />

      <ProjetsPreviewDrawer
        open={!!projets.previewItem}
        item={projets.previewItem}
        onClose={projets.closePreview}
        onEditFromPreview={projets.openEditFromPreview}
      />

      <ProjetsDeleteDrawer
        open={!!projets.deleteItem}
        item={projets.deleteItem}
        deleting={projets.deleting}
        onClose={projets.closeDelete}
        onConfirm={projets.onDelete}
      />

      <AdminMediaPickerDrawer
        open={projets.mediaPickerOpen}
        onClose={projets.closeMediaPicker}
        onSelect={projets.handleSelectMedia}
        title="Choisir une image"
        subtitle="Sélectionnez une image pour illustrer le projet."
        defaultCategory={PROJETS_MEDIA_CATEGORY_DEFAULT}
      />
    </div>
  );
}